import script from "./FullService.vue?vue&type=script&lang=js"
export * from "./FullService.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__